import { IBrasilApiCEP } from '../../shared/types/brasil-api-cep.interface';
import { IBrasilApiStates } from '../../shared/types/brasil-api-state.interface';
import { IBrasilAPICities } from '../../shared/types/brasil-api-city.interface';
import RequestV2 from './request-v2.http';

export default class BrasilService {
    private static uri = 'brazil';

    public static async getDataByCep(cep: string): Promise<IBrasilApiCEP> {
        try {
            const request = await RequestV2.get(`${this.uri}/cep/${cep}`);
            return request.data;
        } catch (error) {
            throw new Error('CEP não encontrado');
        }
    }

    public static async getStates(): Promise<IBrasilApiStates[]> {
        try {
            const request = await RequestV2.get(`${this.uri}/state`);
            return request.data;
        } catch (error) {
            throw new Error(
                'Não foi possível encontrar os estados brasileiros',
            );
        }
    }

    public static async getCitiesByState(
        uf: string,
    ): Promise<IBrasilAPICities[]> {
        try {
            if (!uf) {
                return [];
            }
            const request = await RequestV2.get(`${this.uri}/state/${uf}/city`);
            return request.data;
        } catch (error) {
            throw new Error(
                'Não foi possível encontrar as cidades brasileiras',
            );
        }
    }
}
